
export class BranchesDto {
    branchId?: number;
    branchName:string;
  }
  
  export const BranchesDtoDefault : BranchesDto = {
    branchId: 0,
    branchName:"",
  };
  
  